import { Button } from "@/components/ui/button";
import { 
  ListTodo, 
  Calendar, 
  StickyNote 
} from "lucide-react";

export type WorkspaceItemType = 'task' | 'appointment' | 'note';

interface WorkspaceActionBarProps {
  onAdd: (type: WorkspaceItemType) => void;
  activeType?: WorkspaceItemType | null;
}

export function WorkspaceActionBar({ onAdd, activeType }: WorkspaceActionBarProps) {
  const actions: { type: WorkspaceItemType; label: string; icon: React.ElementType; shortLabel: string }[] = [
    { type: 'task', label: 'Ajouter une tâche', shortLabel: 'Tâche', icon: ListTodo },
    { type: 'appointment', label: 'Planifier un RDV', shortLabel: 'RDV', icon: Calendar },
    { type: 'note', label: 'Ajouter une note', shortLabel: 'Note', icon: StickyNote },
  ];

  return (
    <div className="flex items-center gap-2 p-3 bg-muted/50 rounded-xl border">
      <span className="text-xs text-muted-foreground font-medium mr-1 hidden sm:block">
        Ajouter :
      </span>
      {actions.map(({ type, label, shortLabel, icon: Icon }) => (
        <Button
          key={type}
          variant={activeType === type ? "default" : "outline"}
          size="sm"
          className="h-9 gap-1.5 text-xs flex-1 sm:flex-none"
          onClick={() => onAdd(type)}
          title={label}
        >
          <Icon className="w-4 h-4" />
          <span className="hidden sm:inline">{shortLabel}</span>
          <span className="sm:hidden">+</span>
        </Button>
      ))}
    </div>
  );
}
